import { render, staticRenderFns } from "./product_1688.vue?vue&type=template&id=37109f00&scoped=true&"
import script from "./product_1688.vue?vue&type=script&lang=js&"
export * from "./product_1688.vue?vue&type=script&lang=js&"
import style0 from "./product_1688.vue?vue&type=style&index=0&id=37109f00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37109f00",
  null
  
)

export default component.exports